import { useCallback } from 'react';

import { PopupNames } from 'contexts/PopupContext';

import { usePopup } from 'hooks/usePopup';

export const useUploadPhotoPopup = () => {
  const { handleOpenForce, handleClose, handleAction } = usePopup(
    PopupNames.UploadPhoto
  );

  handleAction.current = (action: { type: string }) => {
    if (action.type === 'close') {
      handleClose();
    }
  };

  const handleOpenPopup = useCallback(() => {
    handleOpenForce(null);
  }, [handleOpenForce]);

  return {
    handleOpenPopup,
  };
};
